import { useState } from "react";

const Nutrition = ({ nutrition, handleNutritionChange }) => {
  const [error, setError] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;

    let floatValue = parseFloat(value); //Allows Float Regex

    if (isNaN(value)) {
      // Convert integer to float format (12 -> 12.0)
      // let formattedValue = value;
      // if (value !== "" && !value.includes(".")) {
      //     formattedValue = `${value}.0`;
      // }

      setError((prevErrors) => ({
        ...prevErrors,
        [name]: "Only numeric values allowed",
      })); // Clear error
    } else {
      floatValue = floatValue % 1 === 0 ? floatValue.toFixed(1) : floatValue;
      setError((prevErrors) => ({ ...prevErrors, [name]: "" }));
      handleNutritionChange({ target: { name, value: floatValue } }); // Update parent state
    }
  };

  return (
    <div className="flex flex-col items-center ">
      <div className="w-full max-w-2xl my-7 space-y-3 overflow-auto">
        <h2 className="text-xl mb-6 font-semibold text-center text-white">
          Nutrition Information
        </h2>
        <table className="min-w-full  shadow-md table-auto bg-gray-700 text-gray-200 rounded-lg text-center">
          <thead>
            <tr>
              <th className="px-4 py-2 text-center">Item Attributes</th>
              <th className="px-4 py-2 text-center">Value</th>
            </tr>
          </thead>
          <tbody>
            {Object.keys(nutrition).map((nutrition, index) => (
              <tr key={index} className="border-sm border-gray-600 text-center">
                <td className="px-4 py-2 capitalize text-center">
                  {nutrition}
                </td>

                <td className="px-4 py-2 text-center">
                  <input
                    type="number"
                    name={nutrition}
                    value={nutrition[nutrition]}
                    onChange={handleChange}
                    step="any" // Allows decimals
                    min="0" // Prevents negative values (optional)
                    className="border rounded px-4 py-2 bg-gray-600 text-gray-200 w-72 text-center"
                    placeholder="Enter a numeric value"
                    required
                  />

                  {error[nutrition] && (
                    <p className="text-red-400 text-xs mt-1">
                      {error[nutrition]}
                    </p>
                  )}
                  {!error[nutrition] && (
                    <p className="text-gray-400 text-xs mt-1">
                      Example: 12.5, 0.75, or 100
                    </p>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Nutrition;
